<template>
  <div class="facility-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ $t('facilities.title') }}</h2>
      <b-button variant="primary" @click="createFacility">
        <i class="fas fa-plus mr-2"></i>{{ $t('facilities.create_button') }}
      </b-button>
    </div>
    <CrudTable :columns="fields" :data-sources="facilities" :pagination="paginationInfo" :loader="isLoading"
      list-url="/facilities" @search="handleSearch" @filter="handleFilter" @refresh="fetchFacilities" ref="action-table">
      <template #cell(name)="data">
        <div class="font-weight-bold">{{ data.item.name || 'N/A' }}</div>
      </template>
      <template #cell(is_active)="data">
        <div>{{ data.item.is_active ? $t('facilities.status_active') : $t('facilities.status_inactive') }}</div>
      </template>
      <template #cell(actions)="data">
        <div class="d-flex gap-2">
          <b-button variant="outline-primary" size="sm" @click="editFacility(data.item)">
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button variant="outline-danger" size="sm" @click="confirmDelete(data.item)">
            <i class="fas fa-trash"></i>
          </b-button>
        </div>
      </template>
    </CrudTable>
    <ConfirmDeleteModal v-if="selectedFacility" :show.sync="showDeleteModal" :item-id="selectedFacility.id"
      delete-url="/facilities" :message="$t('facilities.confirm_delete_message', { facility: selectedFacility.name })"
      success-message="$t('facilities.deleted_successfully')" error-message="$t('common.something_went_wrong')"
      @deleted="handleItemDeleted" />

  </div>
</template>

<script>
import { request } from "@/Util/Request";
import CrudTable from "@/components/CrudTable.vue";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";


export default {
  name: "FacilityList",
  components: {
    CrudTable,
    ConfirmDeleteModal
  },
  data() {
    return {
      facilities: [],
      isLoading: false,
      showDeleteModal: false,
      selectedFacility: null,
      currentPage: 1,
      perPage: 10,
      sortBy: "created_at",
      sortDesc: true,
      filters: {
        search: "",
        status: null,
      },
      fields: [
        { key: "name", label: this.$t("facilities.table_header_name"), sortable: true, sortDirection: "asc" },
        { key: "actions", label: this.$t("common.actions") },
      ],
      paginationInfo: {
        from: 0,
        to: 0,
        total: 0,
      },
    };
  },
  methods: {
    handleSearch(search) {
      this.filters.search = search;
      this.currentPage = 1;
      this.fetchFacilities();
    },
    handleFilter(filter) {
      this.filters = { ...this.filters, ...filter };
      this.currentPage = 1;
      this.fetchFacilities();
    },
    createFacility() {
      this.$router.push("/admin/facilities/create");
    },
    editFacility(facility) {
      this.$router.push(`/admin/facilities/${facility.id}/edit`);
    },
    confirmDelete(facility) {
      this.selectedFacility = facility;
      this.showDeleteModal = true;
    },
    handleItemDeleted() {
      this.$refs['action-table'].refreshTableData();
      this.$bvToast.toast(this.$t('hotel_facilities.deleted_successfully'), {
        title: this.$t('common.success'),
        variant: 'success',
        solid: true,
      });
      this.showDeleteModal = false;
      this.selectedHotelFacility = null;
    },
    async fetchFacilities() {
      try {
        this.isLoading = true;
        const response = await request({
          method: "get",
          url: "/facilities",
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            sort_by: this.sortBy,
            sort_desc: this.sortDesc,
            ...this.filters,
          },
        });
        if (response.data && response.data.data) {
          this.facilities = response.data.data;
          if (response.data.meta) {
            this.paginationInfo = {
              from: response.data.meta.from || 0,
              to: response.data.meta.to || 0,
              total: response.data.meta.total || 0,
            };
          }
        } else {
          this.facilities = [];
          this.paginationInfo = {
            from: 0,
            to: 0,
            total: 0,
          };
        }
      } catch (error) {
        console.error("Error fetching facilities:", error);
        this.facilities = [];
        this.paginationInfo = {
          from: 0,
          to: 0,
          total: 0,
        };
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.fetchFacilities();
  },
};
</script>

<style scoped>
.facility-list {
  padding: 20px;
}
</style>